import React, { Component } from 'react';
import './EventAbstractContainer.css'
import BGImage from '../../../../Utilities/defaultImage.svg'
import DynamicImage from './DynamicImage'

//import axios from 'axios'


class EventAbstractContainer extends Component {
    constructor(props){
        super(props)
        this.state={
        }
    }

    componentDidMount(){
        

    }

    getClassName=()=>{
        let className = "EventContainer" 
        return className
    }

    loadImageUrl=()=>{
        if(this.props.eventDetail.Event_Images[0])
        {
            return 'url('+this.props.eventDetail.Event_Images[0].url+')'
        }
        else
        {
            return `url(${BGImage})`
        }
    }

    loadImageAdjust=()=>{
        if(this.props.eventDetail.Event_Images[0])
        {
            return ` contrast(${this.props.eventDetail.Event_Images[0].imageAdjust.contrast}%) hue-rotate(${this.props.eventDetail.Event_Images[0].imageAdjust.hue}deg) brightness(${this.props.eventDetail.Event_Images[0].imageAdjust.brightness}%) saturate(${this.props.eventDetail.Event_Images[0].imageAdjust.saturate}%) sepia(${this.props.eventDetail.Event_Images[0].imageAdjust.sepia}%) invert(${this.props.eventDetail.Event_Images[0].imageAdjust.invert}%) blur(${this.props.eventDetail.Event_Images[0].imageAdjust.blur}px) opacity(${this.props.eventDetail.Event_Images[0].imageAdjust.opacity}%)`
        }
        else
        {
            return null
        }
    }

    render(){
        
        return(
            <div className={this.getClassName()}> 
                <div className="EventTitleContainer">
                    <div className="EventTitle" onClick={()=>{this.props.abstractFieldOnClick(1)}}>{this.props.eventDetail.Event_Title}
                    </div>
                </div>
                <div className="Image" onClick={()=>{this.props.abstractFieldOnClick(4)}} >
                    <DynamicImage eventImages={this.props.eventDetail.Event_Images}/>
                </div>
                <div className="EventSubTitle" onClick={()=>{this.props.abstractFieldOnClick(2)}}>{this.props.eventDetail.Event_SubTitle}</div>
                <div className="EventTextBlock">     
                     <p className="block-with-text" onClick={()=>{this.props.abstractFieldOnClick(3)}}>{this.props.eventDetail.Event_Story}</p>
                </div>
                <div className="JumpToDetailButton">{"深入專題"}</div>
            </div>
        )
    }
}

export default EventAbstractContainer
